import {CircularProgress, InputAdornment} from '@material-ui/core';
import {Async, isLoaded, isLoading} from 'Core/models/Async';
import {EmptyString, NonEmptyString, StringUnion} from 'Core/models/EmptyString';
import {Either, isLeft, isRight} from 'fp-ts/lib/Either';
import React, {useState} from 'react';
import {Errors} from 'Shared/components/ErrorPopover';
import ValidatableTextField from 'Shared/components/ValidatableTextField';
import './ValidatableTextInput.sass';

type ValidatableTextInputProps = {
  value: Async<Either<StringUnion, NonEmptyString>>;
  onValidate: (username: string) => void;
  label: string;
  className?: string;
  disabled?: boolean;
  additionalErrors?: string[];
};

const ValidatableTextInput = (props: ValidatableTextInputProps) => {
  const [hasBeenBlurred, setHasBeenBlurred] = useState(false);
  const additionalErrors = props.additionalErrors || [];
  const errors = isLoaded(props.value)
    ? Errors.standardErrors({
        value:
          isLeft(props.value.Data) && props.value.Data.left instanceof EmptyString
            ? ['Please supply a value.', ...additionalErrors]
            : isLeft(props.value.Data)
            ? props.label === 'Username'
              ? ['Username is not available.', ...additionalErrors]
              : [`${props.label} is invalid`, ...additionalErrors]
            : additionalErrors,
      })
    : Errors.standardErrors({value: []});
  const showSuccessBorder = isLoaded(props.value) && isRight(props.value.Data) && !errors.value.length;

  return isLoaded(props.value) || isLoading(props.value) ? (
    <ValidatableTextField
      InputProps={{
        endAdornment: <InputAdornment position="end">{isLoading(props.value) && <CircularProgress />}</InputAdornment>,
      }}
      label={props.label}
      disabled={props.disabled}
      errors={errors}
      showErrors={errors => hasBeenBlurred && errors.value.length > 0}
      textInputClassName={`${showSuccessBorder && 'validatable-text-input'} ${props.className}`}
      onBlur={() => setHasBeenBlurred(true)}
      onChange={value => {
        setHasBeenBlurred(true);
        props.onValidate(value);
      }}
      value={isLeft(props.value.Data!) ? props.value.Data.left.value : props.value.Data!.right.value}
    />
  ) : (
    <>An error has occurred.</>
  );
};

export default ValidatableTextInput;
